import SettingTypes from "@/utils/setting-types";
import { getURLSearchParma } from "@/utils/foundation";

export default {
  name: "doctor-list",
  label: {
    get title() {
      const businessType =  getURLSearchParma("businessType") || '';
      return businessType === 'LIFE' ? "美容师列表" : "医生列表";
    },
    icon: require("@/assets/icon-component-label_Goods.png"),
    limit: 20,
  },
  sort: 5,
  data: {
    title: "主标题",
    show_all: true,
    // 布局方式：list | scroll
    layout: "list",
    doctors: [],
  },
  settings: {
    show_all: {
      type: SettingTypes.switch,
      label: "显示全部医生入口",
    },
    title: {
      type: SettingTypes.input,
      label: "主标题",
    },
    layout: {
      type: SettingTypes.radio_button,
      label: "显示样式",
      options: [
        { label: "横版", value: "list" },
        { label: "竖版", value: "scroll" },
      ],
    },
    doctors: {
      type: SettingTypes.custom,
    },
  },
};
